import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from "moment";
import _ from 'lodash';
import {DatabaseProvider} from "../database/database";
import { Storage } from "@ionic/storage";
import {OrderProvider} from "../order/order";
import { forkJoin } from 'rxjs';

@Injectable()
export class UtilityProvider {
  constructor(public http: HttpClient, public database: DatabaseProvider, public storage: Storage, public orderService: OrderProvider) {}

  public formatDate(date, format) {
    let myMoment: moment.Moment
    if (date.seconds) {
      myMoment = moment.unix(date.seconds);
    } else {
      myMoment = moment(date);
    }
    return myMoment.format(format);
  }

  async asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array)
    }
  }

  public isPatientDOBCorrect(patient) {
    return /^(2\d{3}|19\d{2})-(0?[1-9]|1[012])-(0?[1-9]|[12][0-9]|3[01])$/.test(patient.dob);
  }

  checkBatch(order_batch, last_rx)  {
    return new Promise((resolve, reject) => {
      _.forEach(order_batch, (batch, idx) => {
        if(batch.order_batch === last_rx.doctor.id + '_' + last_rx.doctor.last_name)  {
          resolve(idx)
        }
      });
      reject(null);
    });
  }

  getDayString(numericDay: number)  {
    var weekday=new Array(7);
      weekday[0]="Sunday";
      weekday[1]="Monday";
      weekday[2]="Tuesday";
      weekday[3]="Wednesday";
      weekday[4]="Thursday";
      weekday[5]="Friday";
      weekday[6]="Saturday";

      return weekday[numericDay];
  }

  getTimeString(numbericTime: number) {
    let datestring = '1/1/1970 ' + numbericTime + ':00';
    return moment(datestring).format('hh:mm A');
  }

  getNursingHomeId(rx) {
    console.log("DOC AND LOC: "+rx.doctor.id + " - " + rx.location.name);
    return this.database.getNursingHomeByLocationAndDoctor(rx.doctor.id, rx.location.name)
      .valueChanges()
      .take(1)
      .map((nursinghomes) => {
        console.log(nursinghomes);
        if (nursinghomes.length > 0) {
          return nursinghomes[0]["id"];
        }
      })
  }

  async isPatientInExistingBatch(patient_id) {
    let ret = false;
    let order_batch = await this.storage.get('RetinaOrderBatch');
    order_batch = order_batch? order_batch : [];
    all:
      for (let batch of order_batch) {
        for (let rx of batch.rx) {
          if (rx.patient.id === patient_id) {
            ret = true;
            break all;
          }
        }
      }
      return ret;
  }

  pad(num, padlen, padchar) {
    var pad_char = typeof padchar !== 'undefined' ? padchar : '0';
    var pad = new Array(1 + padlen).join(pad_char);
    return (pad + num).slice(-pad.length);
  }


  public reOrderLastRx(patient, clinic_id, clinic_name, note) {
    //temporary patch to make primary_location.name == clinic_name
    if (patient.last_rx.location.name === "Primary Location")
      patient.last_rx.location.name = clinic_name;
    forkJoin(
      [
        this.getNursingHomeId(patient.last_rx),
        this.database.getDoc(`clinics/${clinic_id}/doctors/`, patient.last_rx.doctor.id).get().take(1),
        this.database.getDoc(`clinics/${clinic_id}/patients/${patient.id}/prescriptions/`, patient.last_rx.rx_id).get().take(1)
      ]
    ).subscribe(([nursingHomeId, doctor, rxSnapshot]) => {
      console.log(doctor);
      const rx = rxSnapshot.data();
      const batchname = rx.doctor.id + '_' + rx.doctor.last_name;
      const new_order = {'order_batch': batchname, 'signature': doctor.get("signature")};
      //temporary while Lucentis medication type is still in circulation
      if (rx.medication === "Lucentis")
        rx.medication = "Lucentis PFS";
      if (rx.location.name === "Primary Location")
        rx.location.name = clinic_name;

      if (note) {
        rx.note = note;
      } else {
        rx.note = null;
      }

      rx.nursing_home_id = nursingHomeId;
      rx.injectiondate = null;

      rx.rx_id = this.database.createId();
      let last_rx_patient = {...patient};
      delete last_rx_patient.last_rx;
      rx.patient = last_rx_patient;
      new_order['rx'] = [rx];
      this.storage.get('RetinaOrderBatch').then((order_batch) => {
        if (order_batch) {
          this.checkBatch(order_batch, rx)
            .then((idx) => {
              let index = parseInt(idx.toString());
              order_batch[index]['rx'].push(rx);
              this.storage.set('RetinaOrderBatch', order_batch).then(() => {
                this.orderService.updateBadge();
              });
            })
            .catch((error) => {
              order_batch.push(new_order);
              this.storage.set('RetinaOrderBatch', order_batch).then(() => {
                this.orderService.updateBadge();
              });
            });
        } else {
          let base_order: any = [];
          base_order.push(new_order);
          this.storage.set('RetinaOrderBatch', base_order).then(() => {
            this.orderService.updateBadge();
          });
        }
      });
    });
  }

}


// WEBPACK FOOTER //
// ./src/providers/utility/utility.ts